import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00a77ab1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=00a77ab1&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a77ab1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsAsideCategories: require('/web/components/objects/AsideCategories.vue').default,LinkedObjectPublic: require('/web/components/LinkedObjectPublic.vue').default,ObjectsPublicSharedBlocksImages: require('/web/components/objects/public/shared-blocks/Images.vue').default,ObjectsPublicSharedBlocksFreeInfographicImage: require('/web/components/objects/public/shared-blocks/FreeInfographicImage.vue').default,ObjectsPublicDescr: require('/web/components/objects/public/Descr.vue').default,ObjectsPublicSharedBlocksQuotes: require('/web/components/objects/public/shared-blocks/quotes/Quotes.vue').default,ObjectsPublicSharedBlocksFacts: require('/web/components/objects/public/shared-blocks/facts/Facts.vue').default,ObjectsPublicSharedBlocksTgbs: require('/web/components/objects/public/shared-blocks/tgbs/Tgbs.vue').default,ObjectsPublicSharedBlocksTables: require('/web/components/objects/public/shared-blocks/tables/Tables.vue').default,AboutAuthor: require('/web/components/AboutAuthor.vue').default})
